<template>
  <v-card class="rounded-card card-shadow fill-height" color="primary">
    <v-card-text class="text--primary pa-5">
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-icon size="100" color="white">mdi-chat-processing-outline</v-icon>
          <div class="d-flex flex-column justify-center white--text">
              <span class="headline font-weight-bold ml-3">
              {{ total }} perguntas pendentes
            </span>
            <div class="ml-3">
              Não deixe seus clientes esperando por uma resposta.
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    perguntas: Object,
  },
  computed: {
    total() {
      if (!this.perguntas || !this.perguntas.total) {
        return 0;
      }
      return this.perguntas.total;
    },
  },
};
</script>
